<header class="relative w-full border-b border-gray-200 bg-background py-5">
  <div class="fluid-container flex w-full items-center justify-between gap-2">
    <a class="flex items-center gap-2" [routerLink]="PAGE_ROUTES.HOME">
      <img src="assets/media/logos/logo.svg" alt="logo" class="h-8 w-auto object-contain"/>
      <span class="text-lg font-semibold text-secondary-foreground">Sapec Software</span>
    </a>
    <div class="flex flex-row-reverse gap-3 lg:flex-row">
      @if (viewportSizes.width < 1024) {
        <app-header-navigation-mobile/>
      } @else {
        <div class="flex items-center gap-8">
          @for (item of menuItems; track item) {
            <span
              [routerLink]="item.route"
              routerLinkActive="text-gray-900"
              [routerLinkActiveOptions]="{ exact: item.route === PAGE_ROUTES.HOME }"
              class="cursor-pointer whitespace-nowrap text-disabled transition-opacity duration-200 hover:opacity-70"
            >{{ item.label }}</span
            >
          }
          <div class="flex items-center gap-3">
            <a
              hlmBtn
              size="md"
              variant="ghost"
              class="flex items-center gap-2 whitespace-nowrap text-disabled hover:text-foreground"
              [href]="employeePortalUrl()"
              target="_blank">
              <lucide-icon name="building-2" size="16"/>
              Employee Portal
            </a>
          </div>

          <a hlmBtn size="md" class="w-[203px] rounded-xl" variant="default" [routerLink]="PAGE_ROUTES.HIRE_US">Schedule
            a Consultation</a>
        </div>
      }

      <button
        hlmBtn
        (click)="selectTheme()"
        class="relative h-[40px] w-[40px] overflow-hidden rounded-[50%]"
        variant="ghost"
        size="icon-md">
        <lucide-icon
          name="sun"
          class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transition"
          [ngClass]="currentTheme.isDark ? 'translate-y-8' : ''"/>
        <lucide-icon
          name="moon"
          class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transition"
          [ngClass]="!currentTheme.isDark ? '-translate-y-8' : ''"/>
      </button>
    </div>
  </div>
</header>
